module.exports = __webpack_public_path__ + "img/stop-11.a25358ee.jpg";